import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";
const apiUrl = process.env.REACT_APP_API_KEY_ADMIN

export const getColaboradores = (filtros, setColaboradores) => {
    api.get(`${apiUrl}/admin/get-colaboradores?id=${filtros.id}&email=${filtros.correo}&nombre=${filtros.nombre}`)
        .then((res) => {
            setColaboradores(res.data)
        })
        .catch((error) => {
            console.log("error", error);

        })
}
